import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { class: "flex items-center justify-center w-full h-full gap-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExplorerIcon = _resolveComponent("ExplorerIcon")!

  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["bg-blue-light rounded h-12 w-48 text-center px-1", _ctx.disabled ? 'cursor-not-allowed text-white' : '']),
    disabled: _ctx.disabled,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
  }, [
    _createElementVNode("span", _hoisted_2, [
      (_ctx.icon && !_ctx.textFirst)
        ? (_openBlock(), _createBlock(_component_ExplorerIcon, {
            key: 0,
            type: _ctx.icon,
            width: 32,
            class: "inline h-12"
          }, null, 8, ["type"]))
        : _createCommentVNode("", true),
      _createElementVNode("span", null, _toDisplayString(_ctx.text), 1),
      (_ctx.icon && _ctx.textFirst)
        ? (_openBlock(), _createBlock(_component_ExplorerIcon, {
            key: 1,
            type: _ctx.icon,
            width: 32,
            class: "inline h-12"
          }, null, 8, ["type"]))
        : _createCommentVNode("", true)
    ])
  ], 10, _hoisted_1))
}